import React, { useEffect } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'  // 라우팅 컴포넌트
import ErrorBoundary from './shared/components/ErrorBoundary'

// 전역 OAuth 토큰 처리 컴포넌트
function AuthTokenHandler({ children }) {
  useEffect(() => {
    // URL에서 토큰 확인 (어느 페이지든 작동)
    const urlParams = new URLSearchParams(window.location.search)
    const accessToken = urlParams.get('access_token')
    const refreshToken = urlParams.get('refresh_token')
    const userId = urlParams.get('user_id')
    
    if (accessToken) {
      console.log('🔑 토큰 감지! 로그인 처리 중...')
      
      // 토큰 저장
      localStorage.setItem('access_token', accessToken)
      if (refreshToken) {
        localStorage.setItem('refresh_token', refreshToken)
      }
      
      // URL 정리 (토큰 파라미터 제거) - 현재 경로와 해시 유지
      const cleanUrl = window.location.pathname + window.location.hash
      window.history.replaceState({}, document.title, cleanUrl)
      
      // 잠시 후 새로고침 (상태 업데이트)
      setTimeout(() => {
        window.location.reload()
      }, 100)
    }
  }, [])
  
  return children
}

function MainApp() {
  return (
    <Router>
      <ErrorBoundary>
        <AuthTokenHandler>
          <App />
        </AuthTokenHandler>
      </ErrorBoundary>
    </Router>
  )
}

export default MainApp